// @flow

import { GroupItem } from './groupItem.styled';
import {
  GroupItemContent,
  GroupItemTitle,
  GroupItemPrice,
  GroupItemText,
} from './groupItemTitle.styled';

export {
  GroupItemContent,
  GroupItemTitle,
  GroupItemPrice,
  GroupItemText,
};

export default GroupItem;
